export function sortBy<T, V>(
  arr: T[],
  getter: (x: T) => V,
  comparator: (a: V, b: V) => number
): T[] {
  return Array.from(arr).sort((a, b) => comparator(getter(a), getter(b)));
}
